export const jobCategories = [
  { value: 'development', label: '개발' },
  { value: 'design', label: '디자인' },
  { value: 'marketing', label: '마케팅' },
  { value: 'planning', label: '기획/PM/PO' },
  { value: 'data', label: '데이터' },
  { value: 'research', label: '연구/R&D' },
  { value: 'sales', label: '영업' },
  { value: 'hr', label: '인사/HR' },
  { value: 'finance', label: '재무/회계' },
  { value: 'operation', label: '운영' },
  { value: 'customer_service', label: '고객 서비스' },
  { value: 'education', label: '교육' },
  { value: 'medical', label: '의료/헬스케어' },
  { value: 'media', label: '미디어/콘텐츠' },
  { value: 'law', label: '법률' },
  { value: 'consulting', label: '컨설팅' },
  { value: 'manufacturing', label: '제조/생산' },
  { value: 'logistics', label: '물류/유통' },
  { value: 'construction', label: '건설/부동산' },
  { value: 'game', label: '게임' },
  { value: 'security', label: '보안' },
  { value: 'translation', label: '번역' },
  { value: 'writing', label: '작가/저술' },
  { value: 'student', label: '학생' },
  { value: 'other', label: '기타' }
];
